import React, { Component, lazy } from 'react';
import { message } from 'antd';
import PropTypes from 'prop-types';
import './RichTextEditor.css';
import 'react-quill/dist/quill.snow.css';
const ReactQuill = lazy(() => import('react-quill'));

class RichTextEditor extends Component {
  constructor (props) {
    super(props);
    this.state = {
      entered_text: 0
    };

    this.reactQuillRef = React.createRef();
    this.updatedTextLength = false;
    this.addedMatcherToPreventHTML = false;
  }

  modules = {
    /* HOTFIX - TEMPORARY DISABLE RTF 1 */
    toolbar: false /* [
      [{ color: [] }],
      ['bold', 'italic', 'underline'],
      [{ list: 'bullet' }, { list: 'ordered' }],
      ['link'],
      ['clean']
    ] */
  }

  componentDidUpdate () {
    if (!this.reactQuillRef.current) return;
    if (!this.updatedTextLength) this.updateEnteredTextLength();
    if (!this.addedMatcherToPreventHTML) this.hotfixDontAllowPasteHTML();
  }

  updateEnteredTextLength () {
    this.updatedTextLength = true;
    const quillEditor = this.reactQuillRef.current.getEditor();
    const enteredTextLength = quillEditor.getLength();
    this.setState({ entered_text: enteredTextLength });
  }

  hotfixDontAllowPasteHTML () {
    this.addedMatcherToPreventHTML = true;
    /* HOTFIX - TEMPORARY DISABLE RTF 3 - PASTE HTML -> PLAIN TEXT */
    const quillEditor = this.reactQuillRef.current.getEditor();
    quillEditor.clipboard.addMatcher(Node.ELEMENT_NODE, function (node, delta) {
      delta.ops.length = 0;
      delta.ops = [{
        insert: node.innerText
      }];
      return delta;
    });
  }

  checkCharacterCount = () => {
    const quill = this.reactQuillRef.current.getEditor();
    const { limit } = this.props;
    const quillLength = quill.getLength();
    if (limit) {
      quill.on('text-change', function (delta, old, source) {
        if (quillLength > limit) {
          quill.deleteText(limit, quill.getLength());
        }
      });
      this.setState({ entered_text: quillLength });
    }
  };

  /* HOTFIX - TEMPORARY DISABLE RTF 2 */
  onChange = (value) => {
    if (!value) return;
    const hotfixValue = value.replace(/<p>/g, '').replace(/<\/p>/g, '\r\n');
    if (this.props.onEditorChange) this.props.onEditorChange(hotfixValue);
    else if (this.props.onChange) this.props.onChange(hotfixValue);
  }

  onPasteText = () => {
    // Settimeout of 0 to avoid getting empty text processing on Paste
    setTimeout(() => {
      const quill = this.reactQuillRef.current.getEditor();
      const target = document.getElementById('rteditor').querySelector('.ql-editor').innerText;
      let pasteLength = target ? target.length : 0;
      const { limit } = this.props;
      if (pasteLength && pasteLength > limit) {
        quill.deleteText(limit, quill.getLength());
        pasteLength = quill.getLength();
        message.warning('The copied text is more than the text limit, we already removed part of the text, kindly proofread the text.');
      }
      this.setState({ entered_text: pasteLength });
    }, 0);
  }

  render () {
    // const onChange = this.props.onEditorChange || this.props.onChange;
    const value = this.props.initialContent || this.props.value;

    return (
      <div id="rteditor" /* onPaste={this.onPasteText} */>
        <ReactQuill defaultValue={value} onChange={this.onChange}
          onBlur={this.props.onEditorBlur} readOnly={this.props.disabled}
          placeholder={this.props.placeholder ? this.props.placeholder : 'Input content here...'}
          modules={this.modules}
          ref={this.reactQuillRef}
          onKeyDown={this.checkCharacterCount}
          style={{ minHeight: this.props.height || 250, maxHeight: (this.props.height || 250) * 1.5, display: 'flex', flexDirection: 'column' }}
        />
        {this.props.limit && !this.props.hideLimit && <span style={{ display: 'flex', flexDirection: 'row-reverse' }}>{this.state.entered_text}/{this.props.limit}</span>}
      </div>
    );
  }
}

RichTextEditor.propTypes = {
  initialContent: PropTypes.string,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  onEditorChange: PropTypes.func,
  onChange: PropTypes.func,
  limit: PropTypes.number,
  onEditorBlur: PropTypes.func,
  disabled: PropTypes.bool,
  height: PropTypes.number,
  hideLimit: PropTypes.bool
};

export default RichTextEditor;
